
<template>
  <!-- 虚拟表登记 -->
<div class="ti d-flex">
  <div class="d-flex-left">
    <erp-tree @node-click="nodeClick"></erp-tree>
  </div>
  <div class="d-flex-right">
   <!-- 列表 -->
    <div>
        <div style="margin-bottom: 5px;">
           <el-button @click="searchs">搜索</el-button>
           <el-button @click="add" v-if="ERP.isPermission(4007005001)">新增</el-button>
           <el-button @click="del" v-if="ERP.isPermission(4007005002)">删除</el-button>
           <el-button @click="list_update" v-if="ERP.isPermission(4007005003)">批量修改</el-button>
         </div>

         <div style="margin-bottom: 10px;">
           <el-descriptions :column="2" border size="mini" :labelStyle="{width: '100px'}" :contentStyle="{width:'43%'}">
             <el-descriptions-item label="仪表类型">
               <el-select size="mini" style="width: 100%" v-model="data.meter_type_id" filterable clearable placeholder="类型" class="kuan">
                 <el-option v-for="item in meter_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
               </el-select>
             </el-descriptions-item>
             <el-descriptions-item label="当前房产">
               <el-select style="width:100%" v-model="data.house" class="search" size="mini" filterable remote clearable reserve-keyword placeholder="可搜索房产" :remote-method="remoteMethod":loading="loading">
                   <el-option v-for="item in selectList" :key="item.house" :label="item.house" :value="item.house"></el-option>
                 </el-select>
             </el-descriptions-item>
             <el-descriptions-item label="户号">
               <el-input size="mini" placeholder="户号" v-model="data.huhao" clearable></el-input>
             </el-descriptions-item>
             <el-descriptions-item label="仪表性质">
               <CheckboxGroup v-model="data.meter_kind">
                   <Checkbox label="计量表"></Checkbox>
                   <Checkbox label="分摊计费表"></Checkbox>
               </CheckboxGroup>
             </el-descriptions-item>
             <el-descriptions-item label="仪表编号">
               <el-input size="mini" placeholder="仪表编号" v-model="data.dummy_meter_id" clearable></el-input>
             </el-descriptions-item>
             <el-descriptions-item label="收费标准">
               <el-select size="mini" style="width: 100%" v-model="data.charge_id" filterable clearable placeholder="收费标准" class="kuan">
                 <el-option v-for="item in share_like" :key="item.id" :label="item.name" :value="item.id"></el-option>
               </el-select>
             </el-descriptions-item>
             <el-descriptions-item label="仪表名称">
               <el-input size="mini" placeholder="仪表名称" v-model="data.dummy_meter_name" clearable></el-input>
             </el-descriptions-item>
             <el-descriptions-item label="仪表状态">
              <CheckboxGroup v-model="data.is_using">
                  <Checkbox label="1">在用</Checkbox>
                  <Checkbox label="2">停用</Checkbox>
              </CheckboxGroup>
             </el-descriptions-item>
           </el-descriptions>
         </div>


         <!-- 数据列表 -->
         <div style="width: 100%;margin-top: 5px;">
           <el-table ref="multipleTable" :data="tableData" height="500" border tooltip-effect="dark" style="position:relative;width: 100%;" @selection-change="handleSelectionChange">
               <el-table-column type="selection"  width="55"></el-table-column>
               <el-table-column prop="HouseName" label="所在房产" show-overflow-tooltip></el-table-column>
               <el-table-column prop="tname" label="仪表类型" width="120"></el-table-column>
               <el-table-column prop="" label="户号"  width="120" ></el-table-column>
               <el-table-column prop="dummy_meter_id" label="仪表编号"  width="120" ></el-table-column>
               <el-table-column prop="dummy_meter_name" label="仪表名称"  width="200" ></el-table-column>
               <el-table-column prop="cname" label="收费标准"  width="200" ></el-table-column>
               <el-table-column prop="meter_kind" label="仪表性质"  width="120" ></el-table-column>
               <el-table-column prop="is_using"  label="是否在用" width="120"></el-table-column>
               <el-table-column label="操作" width="120">
                 <template slot-scope="scope">
                   <div style="color: blue;cursor: pointer;" @click='getUpdate(scope.row.id)' v-if="ERP.isPermission(4007005004)">编辑</div>
                 </template>
               </el-table-column>
           </el-table>
         </div>
        <v-divider></v-divider>
        <div class="pages">
          <Page :total="total" :page-size="page" @on-change="change"  show-total />
        </div>
      </div>
    </div>

    <!-- 新增 -->
    <Modal
      v-model="addmodel"
      width="1000"
      title="新增虚拟表"
      okText="保存"
      :mask="masks"
      :loading="loadingModal"
      @on-ok="orderAdd">
      <div style="height: 550px;overflow: auto;">
          <div class="cdj_div">新增虚拟表</div>
           <div class="cdj_table">
              <div class="cdj_display">
                <!-- 左 -->
                <div class="cdj_left">
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>仪表编号</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.dummy_meter_id"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>仪表名称</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.dummy_meter_name"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>倍率</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.dynameter"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background">排序编号</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.sort"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background">备注</div>
                    <div class="cdj_el-input">
                        <el-input v-model="houesmoney.remark" type="textarea" :rows="2"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>仪表状态</div>
                    <div class="cdj_el-input" style="margin-top: 2px;">
                      <RadioGroup v-model="houesmoney.is_using">
                          <Radio label="1">在用</Radio>
                          <Radio label="2">停用</Radio>
                      </RadioGroup>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background">报告类型</div>
                    <div class="cdj_el-input" style="margin-top: 2px;">
                        <CheckboxGroup v-model="houesmoney.report_type_id">
                            <Checkbox label="1">仪表用量表</Checkbox>
                            <Checkbox label="2">公共能耗表</Checkbox>
                            <Checkbox label="3">能源汇总表</Checkbox>
                            <Checkbox label="4">电力负荷估算表</Checkbox>
                            <Checkbox label="5">电力负荷汇总表</Checkbox>
                        </CheckboxGroup>
                    </div>
                  </div>
                 <!-- <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>能耗类型</div>
                    <div class="cdj_el-input">
                      <RadioGroup v-model="houesmoney.energy_type">
                          <Radio label="1">业主分摊</Radio>
                          <Radio label="2">物业包干制</Radio>
                      </RadioGroup>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>能耗性质</div>
                    <div class="cdj_el-input">
                      <RadioGroup v-model="houesmoney.energy_nature">
                          <Radio label="1">住宅能耗</Radio>
                          <Radio label="2">商铺能耗</Radio>
                          <Radio label="3">公区能耗</Radio>
                      </RadioGroup>
                    </div>
                  </div> -->
                </div>
                <!-- 右 -->
                <div class="cdj_left">
                  <div class="cdj_left_display">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>所在房产</div>
                    <div class="cdj_el-input">
                        <el-select
                            style="width:100%"
                            v-model="houesmoney.HouseName"
                            class="search"
                            size="mini"
                            filterable
                            remote
                            clearable
                            reserve-keyword
                            placeholder="可搜索房产"
                            :remote-method="remoteMethod"
                            :loading="loading">
                            <el-option
                              v-for="item in selectList"
                              :key="item.house"
                              :label="item.house"
                              :value="item.house">
                            </el-option>
                          </el-select>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background">户号</div>
                    <div class="cdj_el-input" style="display:flex;">
                        <el-input size="mini" v-model="houesmoney.house_number"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>仪表性质</div>
                    <div class="cdj_el-input">
                      <RadioGroup v-model="houesmoney.meter_kind">
                          <Radio label="0">计量表</Radio>
                          <Radio label="1">分摊计费表</Radio>
                      </RadioGroup>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>仪表类型</div>
                    <div class="cdj_el-input">
                      <el-select v-model="houesmoney.meter_type_id" style="width: 100%" clearable size="mini" placeholder="仪表类型">
                        <el-option v-for="item in meter_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>收费标准</div>
                    <div class="cdj_el-input">
                      <el-select v-model="houesmoney.charge_id" style="width: 100%" clearable size="mini" placeholder="收费标准">
                        <el-option v-for="item in share_like" :key="item.id" :label="item.name" :value="item.id"></el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background">分摊金额</div>
                    <div class="cdj_el-input" style="display:flex;">
                        <el-input size="mini" :disabled="true"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background">上传附件</div>
                    <div class="cdj_el-input" style="display:flex;">
                        <el-upload
                          class="upload-demo"
                          :action="url"
                          :on-change="handleChange"
                          :file-list="fileList">
                          <el-button size="mini" type="primary">上传</el-button>
                        </el-upload>
                    </div>
                  </div>
                </div>
              </div>
           </div>
          <div class="cdj_div">用量计算公式</div>
            <div class="cdj_table">
               <div class="cdj_display">
                   <el-input v-model="houesmoney.expressions" type="textarea" :rows="3"></el-input>
               </div>
          </div>
          <div class="cdj_div">金额计算公式（为空就表示和用量计算公式一致，一般情况可以不设置）</div>
            <div class="cdj_table">
                <div class="cdj_display">
                <el-input v-model="houesmoney.sum_expressions" type="textarea" :rows="3"></el-input>
            </div>
          </div>
          <div class="cdj_div">读数计算公式</div>
            <div class="cdj_table">
              <div class="cdj_display">
                  <el-input v-model="houesmoney.degrees_expressions" type="textarea" :rows="3"></el-input>
              </div>
          </div>
          备注<br/>
          本操作用于设置虚拟表及虚拟表的收费对象；<br/>
          金额计算公式一般用在其金额不是根据用量乘以单价的情况下，而是根据不同虚拟表的计算结果得来的情况； <br/>
      </div>
    </Modal>

    <!-- 弹窗选择用户 -->
    <Modal
      v-model="modal1"
      width="800"
      title="选择客户"
      @on-ok="roomUser">
      <div>
        <room-user style="height: 600px;" ref="child" :house="house"></room-user>
      </div>
    </Modal>

    <!-- 批量修改 -->
    <Modal
      v-model="update_list"
      width="800"
      :mask="masks"
      ok-text="确定修改"
      title="批量修改"
      :loading="loadingModal"
      @on-ok="updatelist">
      <div style="height: 500px;">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="上传文件" name="first">
              <div>
                <div class="cdj_left_display cdj_top">
                  <div class="cdj_left_display_background">上传文件</div>
                  <div class="cdj_el-input" style="display:flex;">
                      <el-upload
                        class="upload-demo"
                        :action="url"
                        :on-change="handleChange1"
                        :file-list="fileList1">
                        <el-button size="mini" type="primary">上传</el-button>
                      </el-upload>
                  </div>
                </div>
              </div>
              <br/>
              说明<br/>
              表格列的名称不能修改，必须以现在模板中定义名称为准； <br/>
              一次只能批量修改一个文件 <br/>
            </el-tab-pane>
            <el-tab-pane label="模板下载" name="second">
              <div class="cdj_div">下载模板</div>
              <div class="cdj_table">
                  <div class="cdj_display">
                      <div class="cdj_left_display">
                        <div class="cdj_left_display_background">所在房产</div>
                        <div class="cdj_el-input" style="width:600px">
                            <el-select
                                style="width:100%"
                                v-model="up_list.house"
                                class="search"
                                size="mini"
                                filterable
                                remote
                                clearable
                                reserve-keyword
                                placeholder="可搜索房产"
                                :remote-method="remoteMethod"
                                :loading="loading">
                                <el-option
                                  v-for="item in selectList"
                                  :key="item.house"
                                  :label="item.house"
                                  :value="item.house">
                                </el-option>
                              </el-select>
                        </div>
                      </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background">收费标准</div>
                    <div class="cdj_el-input">
                      <el-select v-model="up_list.charge_id" style="width:600px" clearable size="mini" placeholder="收费标准">
                        <el-option v-for="item in share_like" :key="item.id" :label="item.name" :value="item.id"></el-option>
                      </el-select>
                    </div>
                  </div>
                  <div style="margin-top: 10px;">
                    <el-button @click="template">模板下载</el-button>
                  </div>
              </div>
            </el-tab-pane>
          </el-tabs>
      </div>
    </Modal>

</div>

</template>

<script>
import imgurl from "../../../../assets/js/imgurl.js";
const chargeItem_name_id = [];
export default {
  name: "FormsOweMoney",
  data () {
    return {
      activeName:'first',
      url:'',
      masks:false,
      tableData: [],
      house:'',
      modal1:false,
      up_list:{
        house:'',
        charge_id:'',
        file:[],
      },
      houesmoney:{
        id:'',
        dummy_meter_id:'',
        dummy_meter_name:'',
        dynameter:'1',
        sort:0,
        remark:'',
        is_using:'1',
        report_type_id:[],
        HouseName:'',
        house_number:'',
        meter_kind:'1',
        meter_type_id:'',
        charge_id:'',
        expressions:'',
        sum_expressions:'',
        degrees_expressions:'',
        file_id:[],
        energy_type:'',
        energy_nature:'',
      },
      selectList:[],
      dessertsLog:[],
      totallog:0,
      pagelog:12,
      update_list:false,
      calculate:false,
      addmodel:false,
      updateDateModel:false,
      loadingModal:true,
      activeName: 'first',
      startDate:'',
      endDate:'',
      s_startDate:'',
      e_endDate:'',
      chargeitem:[],
      loading:false,
      desserts: '',
      total:0,
      page:12,
      search:'',
      data:{
        pid:'',
        house:'',
        homeName:'',
        s_startDate:'',
        e_endDate:'',
        chargeitemID:[],
        chargeitem_type_id:'',
        chargeItem_name_id:'',
        status:2,
        days:'2',
        start:'',
        name:'',
        meter_type_id:'',
        huhao:'',
        dummy_meter_id:'',
        dummy_meter_name:'',
        meter_kind:[],
        charge_id:'',
        is_using:[],
      },
      calculateData:{
        pid:'',
        homeName:'',
        day_type:'2',
        start_type:'',
        startDate:'',
        endDate:'',
      },
      chargeItem_name_id:[],
      chargeitem_type:[],
      chargeitem_1:[],
      chargeitem_2:[],
      charge:[],
      charges:[],
      charges1:[],
      meter_type_list:[],
      homeName:'',
      house:'',
      count:'',
      isIndeterminate: true,
      developer:'',
      discount_type:[],
      timecount:0,
      ids:'',
      multipleSelection:[],
      share_like:[],
      fileList: [],
      fileList1:[]
    }
  },
  //界面没出来前加载
  created() {
  },
  // 加载数据
  mounted(){
    var login = window.localStorage.getItem('login');
    var token = window.localStorage.getItem('token');
    this.url = this.$myhttp.defaults.baseURL + "/admin/excel?"+"login_name="+login+"&token="+token;
    // this.change(1);
    //常规收费项目
    this.$myhttp.get('admin/common/chargeitem_name',{
      'Content-Type': 'application/json'
      }).then(backdata=>{
        this.chargeitem_1 = backdata.data.data;
        this.chargeitem_2 = backdata.data.data;
    });
    //仪表类型
    this.$myhttp.get('admin/common/meter_type_list',{
      'Content-Type': 'application/json'
      }).then(backdata=>{
        this.meter_type_list = backdata.data.data;
    });
    this.share_charge();
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  //事件
  methods: {
    //批量修改
    list_update(){
      if(!this.data.pid){
        this.$Message.error("点击左边树选择项目");
        return false;
      }
      this.update_list = true;
    },
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    //模板下载
    template(){
      this.$myhttp.get("admin/ShareMeter/template?house="+this.up_list.house+'&charge_id='+this.up_list.charge_id,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
        var login = window.localStorage.getItem('login');
        var token = window.localStorage.getItem('token');
        let url = imgurl+backdata.data.data+'?'+"&login_name="+login+"&token="+token;
        window.open(url, '_blank');
      });
    },
    updatelist(){
      //ERP.showLoading()
      this.$myhttp.post('admin/ShareMeter/list_update',this.up_list,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
           //ERP.hideLoading()
           this.loadingModals();
           if(backdata.data.code == 200){
             this.update_list=false;
             this.change(1);
             this.$Message.success(backdata.data.message);
           }else{
             this.$Message.error(backdata.data.message);
           }
      });
    },
    //批量修改结束
    //编辑查询
    getUpdate(id){
      this.$myhttp.get("admin/ShareMeter/getUpdate?id="+id,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          this.houesmoney = backdata.data.data;
          this.addmodel = true;
      });
    },
    //上传
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-3);
      let list = [];
      this.fileList.map(req=>{
        list.push(req.response)
      })
      this.houesmoney.file_id = list;
    },
    handleChange1(file, fileList) {
      this.fileList1 = fileList.slice(-3);
      let list = [];
      this.fileList1.map(req=>{
        list.push(req.response)
      })
      this.up_list.file = list;
    },
    //收费标准
    share_charge(){
      this.$myhttp.get('admin/common/share_charge?pid='+this.data.pid,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          this.share_like = backdata.data.data;
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //选择客户
    user(){
      this.modal1 = true;
    },
    //点击客户
    roomUser(){
      this.developer = this.$refs.child.getUser();
      this.houesmoney.h_name = this.developer.name;
    },
    //搜索房产
    remoteMethod(query) {
      if (query !== "") {
        // console.log(query);
        this.loading = true;
        this.$myhttp.get("admin/common/house_text2?text=" +query +"&project_id=" +this.data.pid,{
          "Content-Type": "application/json",
          }).then((backdata) => {
            // 异步执行成功后
            this.selectList = backdata.data.data;
            this.loading = false;
          });
      } else {
        this.selectList = [];
      }
    },
    //删除
    del(){
      this.$confirm('确定操作吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ERP.showLoading()
        this.$myhttp.post('admin/ShareMeter/del',this.multipleSelection,{
          'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{ // 异步执行成功后
             ERP.hideLoading()
             if(backdata.data.code == 200){
               this.change(1);
               this.$Message.success(backdata.data.message);
             }else{
               this.$Message.error(backdata.data.message);
             }
        });
      }).catch(() => {

      });
    },

    //新增
    add(){
      if(!this.data.pid){
        this.$Message.error("点击左边树选择项目");
        return false;
      }
      if(this.houesmoney.id){
        this.houesmoney={
          id:'',
          dummy_meter_id:'',
          dummy_meter_name:'',
          dynameter:'1',
          sort:0,
          remark:'',
          is_using:'1',
          report_type_id:[],
          HouseName:'',
          house_number:'',
          meter_kind:'1',
          meter_type_id:'',
          charge_id:'',
          expressions:'',
          sum_expressions:'',
          degrees_expressions:'',
          file_id:[],
          energy_type:'',
          energy_nature:'',
        };
        this.fileList = [];
      }
      this.addmodel = true;
    },
    orderAdd(){
      ERP.showLoading()
      this.$myhttp.post('admin/ShareMeter/add',this.houesmoney,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          ERP.hideLoading()
          this.loadingModals();
          if(backdata.data.code == 200){
            this.addmodel = false;
            this.$Message.success(backdata.data.message);
            this.change(1);
            //this.change(1);
          }else{
            this.$Message.error(backdata.data.message);
          }
      });
    },
    //点击收费项目
    chargeItem_names(){
      this.$myhttp.get("admin/RoomSetUp/chargeItem_name?chargeItem_name_id="+this.data.chargeItem_name_id+"&pid="+this.data.pid,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          this.data.chargeitemID = '';
          this.charges = backdata.data.data;
      });
    },
    chargeItem_names1(){
      this.$myhttp.get("admin/RoomSetUp/chargeItem_name?chargeItem_name_id="+this.houesmoney.xsc_ChargeItemID_id+"&pid="+this.data.pid,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          this.houesmoney.chargeitemID = '';
          this.charges1 = backdata.data.data;
      });
    },
    //获得当前多少页,分页
    change(e){
      this.dates();
      ERP.showLoading()
      this.data.page = e;
      this.$myhttp.post('admin/ShareMeter/index',this.data,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          let data = backdata.data.data;
          this.tableData = data.data;
          this.total = data.count;
          this.page = data.pageSize;
          ERP.hideLoading()
      });
    },
    //时间转换
    dates(){
      //计算费用
      this.calculateData.startDate = '';
      this.calculateData.endDate = '';
      if(this.startDate != null && this.startDate != ''){
        let d = this.startDate;//开始时间
        let startDate = new Date(d).getTime()/1000;
        startDate = Number(startDate).toFixed(0);
        this.calculateData.startDate = startDate;
      }
      if(this.endDate != null && this.endDate != ''){
        let d = this.endDate;//开始时间
        let endDate = new Date(d).getTime()/1000;
        endDate = Number(endDate).toFixed(0);
        this.calculateData.endDate = endDate;
      }
      //搜索
      this.data.s_startDate = '';
      this.data.e_endDate = '';
      if(this.s_startDate != null && this.s_startDate != ''){
        let d = this.s_startDate;//开始时间
        let s_startDate = new Date(d).getTime()/1000;
        s_startDate = Number(s_startDate).toFixed(0);
        this.data.s_startDate = s_startDate;
      }
      if(this.e_endDate != null && this.e_endDate != ''){
        let d = this.e_endDate;//开始时间
        let e_endDate = new Date(d).getTime()/1000;
        e_endDate = Number(e_endDate).toFixed(0);
        this.data.e_endDate = e_endDate;
      }

    },

    //搜索
    searchs(){
      this.change(1);
    },
    // 树组件点击触发
    nodeClick(data) {
      let project = data.tree[0];
      let tree_str=data.tree.map(ret=>{return ret.name}).join('->');
      //console.log(data.tree)
      this.data.pid = data.tree[0]['id'];
      this.data.homeName=tree_str;
      this.houesmoney.HouseName = tree_str;
      this.search=tree_str;
      this.data.house = tree_str;
      this.up_list.house = tree_str;
      this.data.charge_id = '';
      if(this.addmodel == false){
        if(this.update_list == false){
          this.change(1);
          this.chargesc(this.data.pid,this.data.homeName);
        }
      }
      this.share_charge();
    },
    //加载收费项目
    chargesc(pid,homeName){
      this.chargeItem_name_id = [];
      this.$myhttp.get("admin/RoutineExpense/index?pid="+pid+'&homeName='+homeName,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          this.charge = backdata.data.data.charge;
          this.count = backdata.data.data.count;
          this.chargeItem_name_id = backdata.data.data.chargeItem_name_id;
      });
    },
    //弹窗不要关闭
    loadingModals(){
      let _this = this;
      _this.loadingModal=false;
      setTimeout(() => {
        _this.loadingModal = true;
      }, 10)
    },
  },
  watch:{

  },

  components: {
    "erp-tree": () => import('../../Common/erp-tree.vue'),
    "room-user": () => import('../../Common/room-user.vue')
  },

}
</script>
<style scoped>
@import '../../../../assets/css/table.css';
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  width: 20%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.cdj_margin{
  margin-left:1px;
}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
  overflow-x:hidden;
}
.el-checkbox-group{
  margin-top: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Meter/share/Meter.vue